import React from 'react';
import { branch } from 'baobab-react/higher-order';
import Feature from './Feature';

const Features = ({ productFeatures }) => {
	const features = productFeatures.map(
		(feature,index) => <Feature key={ index } feature={ feature } />
	);

	return (
		<section id="features" className="row features">
			<div className="col">
				<h2 className="title">Features</h2>
			</div>
			<div className="callouts">
				{ features }
			</div>
		</section>
    );
};

export default branch({
	productFeatures: ['product', 'features']
}, Features);


// WEBPACK FOOTER //
// ./src/pages/product/Features.js